/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: string): Date | null {
    const it = value.split('.');
    if (it.length == 3) {
      return new Date(+it[2], +it[1] - 1, +it[0]);
    }
    return null;
  }
}
